import { render, staticRenderFns } from "./PvpRewards.vue?vue&type=template&id=88e38b64"
import script from "./PvpRewards.vue?vue&type=script&lang=js"
export * from "./PvpRewards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports